import React, { useEffect, useState } from "react";
import "./index.css";

export default function CommonIcon({ self, ys, ys2 }) {
  const [bol, setBol] = useState(false);
  useEffect(() => {
    console.log(self);
    if (self.photo || self.weixinHeadimgurl) {
      setBol(true);
    } else {
      setBol(false);
    }
  }, []);
  const getDom = () => {
    let dom = "";
    const { name, weixinNickName, username } = self;
    if (name) {
      dom = name.slice(name.length - 2, name.length);
    } else if (weixinNickName) {
      dom = weixinNickName.slice(
        weixinNickName.length - 2,
        weixinNickName.length
      );
    } else {
      dom = username.slice(username.length - 2, username.length);
    }
    return dom;
  };
  return (
    <span>
      {bol ? (
        <img
          src={self.photo || self.weixinHeadimgurl}
          className="commonIcon"
          alt="头像"
          style={ys}
        />
      ) : (
        <div className="commonIconBox" style={ys}>
          <h3 style={ys2}>{getDom()}</h3>
        </div>
      )}
    </span>
  );
}
